import PhotoSwipeLightbox from 'photoswipe/lightbox';
export const initLightbox = () => {
	document.querySelectorAll('.js-gallery').forEach((gallery) => {
		const lightbox = new PhotoSwipeLightbox({
			gallery,
			children: 'a',
			// główny moduł PhotoSwipe ładuje się dopiero przy pierwszym kliknięciu
			pswpModule: () => import('photoswipe'),

			bgOpacity: 0.9,
			showHideAnimationType: 'zoom',
			wheelToZoom: true,

			// polskie etykiety (czytniki ekranu i tooltipy)
			closeTitle: 'Zamknij',
			zoomTitle: 'Powiększ',
			arrowPrevTitle: 'Poprzednie zdjęcie',
			arrowNextTitle: 'Następne zdjęcie',
			errorMsg: 'Nie udało się wczytać zdjęcia.',
			indexIndicatorSep: ' / ',
		});

		lightbox.init();
	});
};
